import update from 'immutability-helper';
import { indexById } from '../indexById/indexById';
import { get as getId } from '../localId/localId';

export const ADD_LOCAL_CLIENT = 'ADD_LOCAL_CLIENT';
export const REMOVE_LOCAL_CLIENT = 'REMOVE_LOCAL_CLIENT';
export const API_LOAD_CLIENTS = 'API_LOAD_CLIENTS';
export const API_REMOVE_CLIENT = 'API_REMOVE_CLIENT';
export const API_CREATE_CLIENT = 'API_CREATE_CLIENT';
export const API_UPDATE_CLIENT = 'API_UPDATE_CLIENT';

const API_LOAD_CLIENTS_FAILED = 'API_LOAD_CLIENTS_FAILED';
const API_LOAD_CLIENTS_LOADING = 'API_LOAD_CLIENTS_LOADING';
const API_LOAD_CLIENTS_LOADED = 'API_LOAD_CLIENTS_LOADED';
const API_REMOVE_CLIENT_FAILED = 'API_REMOVE_CLIENT_FAILED';
const API_REMOVE_CLIENT_LOADING = 'API_REMOVE_CLIENT_LOADING';
const API_REMOVE_CLIENT_SUCCESS = 'API_REMOVE_CLIENT_SUCCESS';
const API_CREATE_CLIENT_FAILED = 'API_CREATE_CLIENT_FAILED';
const API_CREATE_CLIENT_LOADING = 'API_CREATE_CLIENT_LOADING';
const API_CREATE_CLIENT_SUCCESS = 'API_CREATE_CLIENT_SUCCESS';
const API_UPDATE_CLIENT_FAILED = 'API_UPDATE_CLIENT_FAILED';
const API_UPDATE_CLIENT_LOADING = 'API_UPDATE_CLIENT_LOADING';
const API_UPDATE_CLIENT_SUCCESS = 'API_UPDATE_CLIENT_SUCCESS';

const defaultState = { clients: [], loading: false };
const emptyClient = () => ({ id: getId(), name: '', isRemoving: false });
const mapDefaults = client => ({ ...emptyClient(), ...client });

// eslint-disable-next-line object-curly-newline
export const reducer = (state = defaultState, { type, response, id, replaceId, resource }) => {
  switch (type) {
    case API_LOAD_CLIENTS_LOADED:
      return update(state, {
        loading: { $set: false },
        clients: { $set: response.map(mapDefaults) },
      });
    case API_LOAD_CLIENTS_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_CLIENTS_FAILED:
      return update(state, { loading: { $set: false } });
    case ADD_LOCAL_CLIENT:
      return update(state, { clients: { $push: [emptyClient()] } });
    case API_REMOVE_CLIENT_SUCCESS:
    case REMOVE_LOCAL_CLIENT:
      return update(state, { clients: { $splice: [[indexById(id, state.clients), 1]] } });
    case API_REMOVE_CLIENT_FAILED:
      return update(state, { clients: { [indexById(id, state.clients)]: { removing: { $set: false } } } });
    case API_REMOVE_CLIENT_LOADING:
      return update(state, { clients: { [indexById(id, state.clients)]: { removing: { $set: true } } } });
    case API_CREATE_CLIENT_FAILED:
      return update(state, { clients: { [indexById(resource.id, state.clients)]: { saving: { $set: false } } } });
    case API_CREATE_CLIENT_LOADING:
      return update(state, { clients: { [indexById(resource.id, state.clients)]: { saving: { $set: true } } } });
    case API_CREATE_CLIENT_SUCCESS:
      return update(state, { clients: { $splice: [[indexById(replaceId, state.clients), 1, response]] } });
    default:
      return state;
  }
};

export const clients = state => state.clients.clients;
export const loading = state => state.clients.loading;

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/clients/clients.reducer.js